import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'FilterForPipe', pure: true})
export class FilterForPipe implements PipeTransform {
    public transform(val: any[], key, searchText: any): any {
        if (searchText == null || val == null) {
            return val;
        }
        return val.filter(i_val => {
            let z = i_val[key];
            if (!z) {
                z = i_val['name'];
                if (!z){
                    return -1;
                }
            }
            return z.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
        });
    }
}
